/* eslint-disable import/no-dynamic-require */
// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import styles from './styles';

class Helper extends Component {
  state = {};

  static propTypes = {
    classes: PropTypes.object,
    file: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
  };

  static defaultProps = {
    classes: {},
    file: null,
    title: 'Some text',
    description: 'Some text',
  };

  render() {
    const {
      classes,
      file,
      title,
      description
    } = this.props;

    return (
      <div className={classes.mainContainer}>
        <div className={classes.mainInnerContainer}>
          <div className={classes.imageContainer}>
            <img className={classes.image} src={file} alt={'helper'} />
          </div>
          <div className={classes.titleContainer}>
            <p className={classes.titleText}>{title}</p>
          </div>
          <div className={classes.descriptionContainer}>
            <p className={classes.descriptionText}>{description}</p>
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(Helper);
